import { childrenBusinessPageBreadcrumbs } from '@/pages/Business/config';
import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateFunction } from 'react-router-dom';

export const amendmentsBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [...childrenBusinessPageBreadcrumbs(navigate)];

export const amendmentHistoryBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenBusinessPageBreadcrumbs(navigate),
  {
    label: 'Enmiendas',
    onClick: () => navigate('/business/amendments'),
  },
];
